<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col cols="12">
        <v-datetime-picker
          v-model="fuelOperation.date"
          field-name="date"
          rules="required|datetime"
        />
      </v-col>
      <v-col cols="4">
        <validated-text-field
          v-model="fuelOperation.start"
          field-name="fuel_start"
          rules="required"
          type="number"
          step="0.01"
        />
      </v-col>
      <v-col cols="4">
        <validated-text-field
          v-model="fuelOperation.end"
          field-name="fuel_end"
          rules="required"
          type="number"
          step="0.01"
        />
      </v-col>
      <v-col cols="4">
        <validated-text-field
          v-model="fuelOperation.quantity"
          field-name="fuel_quantity"
          rules="required"
          type="number"
          step="0.01"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import VDatetimePicker from '@/components/DatetimePicker.vue'

  export default {
    name: 'EditFuelOperation',
    components: { VDatetimePicker },
    props: {
      fuelOperation: Object,
    },
    computed: {
    },
    watch: {
      'fuelOperation.start': {
        handler () {
          this.fuelOperation.quantity = this.fuelOperation.end - this.fuelOperation.start
        },
        // deep: true,
      },
      'fuelOperation.end': {
        handler () {
          this.fuelOperation.quantity = this.fuelOperation.end - this.fuelOperation.start
        },
        // deep: true,
      },
    },
    methods: {
    },
  }
</script>
